"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DROPDOWN : DAY PICKER : STYLES --------------- ++++++++++ */


var _default = {
  daypickerdropdown: {
    height: (0, _index.pxToEm)(56),
    minWidth: (0, _index.pxToEm)(305),
    maxWidth: (0, _index.pxToEm)(305),
    //pxToEm(255),
    position: 'relative',
    '& .placeholder': {
      width: '100%',
      height: '100%',
      fontSize: (0, _index.pxToEm)(15),
      padding: (0, _index.pxToEm)(18),
      color: _index.theme.color.primary.medium.swatch,
      background: _index.theme.color.light.light.swatch,
      borderRadius: (0, _index.pxToEm)(4),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: _index.theme.boxShadow.small,
      cursor: 'pointer',
      border: "".concat((0, _index.pxToEm)(2), " solid transparent"),
      transition: 'border .2s linear 0s',
      '& .icon': {
        color: _index.theme.color.primary.dark.swatch
      },
      '&:hover': {
        borderColor: _index.theme.color.secondary.light.swatch
      },
      '&.active-true': {
        borderColor: _index.theme.color.primary.medium.swatch
      }
    },
    '& .name-dropdown': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      background: _index.theme.color.light.light.swatch,
      // maxHeight: pxToEm(385),
      width: (0, _index.pxToEm)(325),
      height: (0, _index.pxToEm)(325),
      padding: (0, _index.pxToEm)(25),
      transition: 'all .15s',
      position: function position(props) {
        return props.alignedRight ? 'relative' : 'absolute';
      },
      zIndex: 1,
      right: 0,
      boxShadow: _index.theme.boxShadow.small,
      '&.active-false': {
        height: '0px',
        overflow: 'hidden',
        transition: 'all .15s',
        padding: 0
      },
      '& .datepicker': {
        marginTop: (0, _index.pxToEm)(5)
      }
    }
  }
};
exports.default = _default;